export const ZENDESK_LINK = 'https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=58024455153433';
